export enum FacebookPixelEvent {
	OrderNow = 'Order Now',
	SignInOrJoin = 'Sign in or join',
	LoginFromHome = 'Login from home',
	RegisterFromHome = 'Register from home',
	Login = 'Login',
	Register = 'Register',
	Orders = 'Orders',
	Loyalty = 'Loyalty',
	Logout = 'Logout',
	ArticleCustomize = 'Article Customize',
	MakeOrder = 'Make Order',
}
